import React from 'react'
import styled from 'styled-components'
import { device } from '../../../utils/helpers'

const Wrapper = styled.div`
  margin: 0 0.4rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;

  &:hover > p {
    border-bottom: 4px solid ${props => props.theme.color.borderSecondary};
  }

  @media ${device.tablet} {
    margin: 0 2.5rem;

    &:hover {
      color: ${props => props.theme.color.hoverPrimary};
    }

    &:hover > svg {
      fill: ${props => props.theme.color.borderSecondary};
    }
  }
`

const Text = styled.p`
  padding-bottom: 5px;
  font-size: 16px;
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  box-sizing: border-box;
  border-bottom: 4px solid transparent;

  @media ${device.tablet} {
    font-size: 1.25VW;
    padding-top: 18px;
  }
`

const Icon = styled.div`
  display: none;

  @media ${device.tablet} {
    display: block;
  }
`

const NavItem = ({ children, icon }) => (
  <Wrapper>
    {/* <Square className='square' /> */}
    <Icon>
      {icon}
    </Icon>
    <Text>
      {children}
    </Text>
  </Wrapper>
)

export default NavItem



// WEBPACK FOOTER //
// ./src/components/UI/ScrollNav/NavItem.js